import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuilding,
  faUniversity,
  faUsers,
  faChartLine,
  faShieldAlt,
  faFolder,
  faDollarSign,
  faBolt,
  faCreditCard,
  faLink,
  faRobot,
  faGlobe,
  faSave,
  faTrash,
  faExclamationTriangle,
  faInfoCircle,
  faCheckCircle,
  faTimesCircle,
  faSpinner,
  faPlus,
  faMinus,
  faEdit,
  faEye,
  faDownload,
  faUpload,
  faSearch,
  faFilter,
  faSort,
  faCog,
  faHome,
  faArrowLeft,
  faArrowRight,
  faCaretDown,
  faCaretUp,
  faTimes,
  faCheck,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  // Birthday & Family Icons
  faBirthdayCake,
  faCalendarDay,
  faCalendarAlt,
  faClock,
  faGift,
  faHeart,
  faCalendar,
  faHandshake
} from '@fortawesome/free-solid-svg-icons';

// Centralized icon mapping for CRM components
export const CRM_ICONS = {
  // Tab icons
  'partner-profile': faBuilding,
  'banking-details': faUniversity,
  'contact-management': faUsers,
  'commodity-trading': faChartLine,
  'kyc-compliance': faShieldAlt,
  'document-hub': faFolder,
  'financial-accounting': faDollarSign,
  'credit-rating': faCreditCard,
  'risk-engine': faBolt,
  'partner-services': faLink,
  'ai-notes': faRobot,
  'external-data': faGlobe,
  
  // Action icons
  'save': faSave,
  'delete': faTrash,
  'edit': faEdit,
  'view': faEye,
  'download': faDownload,
  'upload': faUpload,
  'search': faSearch,
  'filter': faFilter,
  'sort': faSort,
  'settings': faCog,
  'home': faHome,
  'add': faPlus,
  'remove': faMinus,
  'close': faTimes,
  'check': faCheck,
  
  // Status icons
  'warning': faExclamationTriangle,
  'info': faInfoCircle,
  'success': faCheckCircle,
  'error': faTimesCircle,
  'loading': faSpinner,
  
  // Navigation icons
  'arrow-left': faArrowLeft,
  'arrow-right': faArrowRight,
  'caret-down': faCaretDown,
  'caret-up': faCaretUp,
  'chevron-down': faChevronDown,
  'chevron-up': faChevronUp,
  'chevron-left': faChevronLeft,
  'chevron-right': faChevronRight,
  
  // Birthday & Family icons
  'birthday-cake': faBirthdayCake,
  'calendar-day': faCalendarDay,
  'calendar-alt': faCalendarAlt,
  'calendar': faCalendar,
  'clock': faClock,
  'gift': faGift,
  'heart': faHeart,
  'handshake': faHandshake
};

// Reusable Icon component
export const CRMIcon = ({ 
  name, 
  className = '', 
  size = 'sm', 
  color, 
  spin = false,
  style = {},
  ...props 
}) => {
  const icon = CRM_ICONS[name];
  
  if (!icon) {
    console.warn(`CRMIcon: Icon "${name}" not found`);
    return null;
  }

  return (
    <FontAwesomeIcon
      icon={icon}
      className={`crm-icon ${className}`}
      size={size}
      color={color}
      spin={spin}
      style={style}
      {...props}
    />
  );
};

// Tab icon component specifically for the navigation tabs
export const CRMTabIcon = ({ tabId, className = '', color }) => {
  return (
    <CRMIcon 
      name={tabId} 
      className={`crm-tab-icon ${className}`}
      size="sm"
      color={color}
    />
  );
};

// Button icon component for action buttons
export const CRMButtonIcon = ({ name, className = '', ...props }) => {
  return (
    <CRMIcon 
      name={name} 
      className={`crm-btn-icon ${className}`}
      size="sm"
      {...props}
    />
  );
};

export default { CRMIcon, CRMTabIcon, CRMButtonIcon, CRM_ICONS }; 